import { gql } from 'graphql-request';
import { request } from '../graphql';

export const GET_SONAR = gql`
query retrieveSonar5AData($filters:LuzmoFiltersInput!, $surveyId: String!, $accessOfDashboardId: String!) {
  retrieveSonar5AData(filters: $filters, surveyId: $surveyId, accessOfDashboardId: $accessOfDashboardId) {
    label
    category
    importance
    value
  }
}
`;

export const GET_SONAR_AVERAGE = gql`
query retrieveSonar5AAverageData($surveyId: String!, $accessOfDashboardId: String!){
  retrieveSonar5AAverageData(surveyId: $surveyId, accessOfDashboardId: $accessOfDashboardId) {
    importance
    value
  }
}
`;

export interface RetrieveSonarData {
  retrieveSonar5AData: Array<SonarFiveAPoint>
}

export interface SonarFiveAPoint {
  label: string;
  category: string;
  importance: number;
  value: number;
  index?: number;
}

export interface RetrieveSonarAverageData {
  retrieveSonar5AAverageData: SonarFiveAAverage
}


export interface SonarFiveAAverage {
  importance: number;
  value: number
}

export type LuzmoFilter = {
  expression: string;
  column_id: string;
  dataset_id: string;
  value: string;
 }




export type LuzmoFiltersInput = {
  luzmoFilters: LuzmoFilter[];
 }

export const retrieveSonarData = (input: {
  filters: LuzmoFiltersInput, surveyId: string, accessOfDashboardId: string,
},  language: string) => request<RetrieveSonarData>(GET_SONAR, input, language);

export const retrieveSonarAverageData = (input: {
  surveyId: string, accessOfDashboardId: string
}, language: string) => request<RetrieveSonarAverageData>(GET_SONAR_AVERAGE, input, language);
